const overrides = new Map<number, boolean>();

export function getFavoriteOverride(videoId: number): boolean | undefined {
  return overrides.get(videoId);
}

export function setFavoriteOverride(videoId: number, active: boolean) {
  overrides.set(videoId, active);
}
